import gql from 'graphql-tag';

export const getCollectionLinesSums = gql`
  query getCollectionLinesSums($where: String!) {
    getCollectionLinesSums(where: $where) {
      materialId
      materialName
      noRecs
      qty
      netWeight
    }
  }
`;

export const gqlGetQuery = gql`
  query getCollections($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollections(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        code
        seriesId
        codePrefix
        codeNumber
        dateCollected
        collectionPointId
        collectorId
        wastereceptionpointId
        legacyAppId
        recordDate
        isActive
        firstDate
        lastDate
        finDispNote
        firstUser
        lastUser
        collectionpoint {
          id
          name
          addressLine1
          addressLine2
          addressArea
          addressCity
          addressDistrict
          phone
        }
        collector {
          id
          name
        }
        wastereceptionpoint {
          id
          name
        }
        collectionLines {
          id
          aa
          materialId
          finDispNote
          qty
          netWeight
          material {
            id
            name
          }
        }
        idocs {
          id
          identificationDocument
        }
      }
      recordCount
    }
  }
`;
